export const CUSTOMER = 'customer';
export const DRIVER = 'driver';
